import types from "@/store/types/SolicitudCredenciales";
import Vue from "vue";

const state = {
  datosSin: {
    resultado: {},
  },
  datosRepresentante: {},
  validacionSegip: { status: false, message: "" },
  validacionEnCurso: {
    exito: false,
    error: false,
    consultando: false,
    mensaje: ''
  },
  formularioEnviado: false,


  datosGuardados: {},
  documentosCredenciales: [],
  documentosCargados: [],
editando: false





};

const getters = {
  [types.getters.GetDatosSin]: (state) => {
    let objSin = state.datosSin;
    return objSin;
  },
  [types.getters.GetDatosRepresentante]: (state) => {
    let objRepresentante = state.datosRepresentante;
    return objRepresentante;
  },
  [types.getters.GetValidacionSegip]: (state) => {
    let objValidacion = state.validacionSegip;
    return objValidacion;
  },
  [types.getters.GetValidacionEnCurso]: (state) => {
    let objValidacion = state.validacionEnCurso;
    return objValidacion;
  },
  [types.getters.GetFormularioEnviado]: (state) => {
    let objFormulario = state.formularioEnviado;
    return objFormulario;
  },

  [types.getters.GetDatosGuardados]: (state) => {
    let objDatos = state.datosGuardados;
    return objDatos;
  },
  [types.getters.GetDocumentosCredenciales]: (state) => {
    return state.DocumentosCredenciales.map((data, index) => {
      data.ref = `refDropzone${index}`;
      data.files = [];
      return data;
    });
  },
  [types.getters.GetDocumentosCargados]: (state) => {
    let objDatos = state.documentosCargados;
    return objDatos;
  },
  [types.getters.GetEditando]: (state) => {
    let objDatos = state.editando;
    return objDatos;
  },
};

const mutations = {
  [types.mutations.SetDatosSin]: (state, obj) => {
    state.datosSin = obj;
  },

  [types.mutations.SetDatosRepresentante]: (state, obj) => {
    state.datosRepresentante = obj;
  },
  [types.mutations.SetValidacionEnCurso]: (state, obj) => {
    state.validacionEnCurso = obj;
  },
  [types.mutations.SetValidacionSegip]: (state, obj) => {
    state.validacionSegip = obj;
  },
  [types.mutations.SetFormularioEnviado]: (state, obj) => {
    state.formularioEnviado = obj;
  },
  [types.mutations.SetDatosGuardados]: (state, obj) => {
    state.datosGuardados = obj;
  },
  [types.mutations.SetDocumentosCredenciales]: (
    state,
    DocumentosCredenciales
  ) => {
    state.DocumentosCredenciales = DocumentosCredenciales;
  },
  [types.mutations.SetDocumentosCargados]: (state, obj) => {
    state.documentosCargados = obj
  },
  [types.mutations.SetEditando]: (state, obj) => {
    state.editando = obj
  },
};

const actions = {
  [types.actions.BuscarYRegistrarDatosSin]: ({ commit }, pObj) => {
    return new Promise((resolve, reject) => {
      commit(types.mutations.SetValidacionEnCurso, {
        exito: false,
        error: false,
        consultando: true,
        mensaje:"Validando con Servicio Nacional De Impuestos"
      });
      Vue.prototype.$http
        .get(`credencial/solicitud_credencial/verificarNit/${pObj}/${localStorage.getItem("tokenC")}`)
        .then((res) => {
          if (res.status == 200) {
            if (res.data.status == 200) {
              commit(types.mutations.SetDatosSin, res.data);
              resolve(res.data);
              commit(types.mutations.SetValidacionEnCurso, {
                exito: true,
                error: false,
                consultando: false,
                mensaje: res.data.message,
              });
            } else {
              commit(types.mutations.SetDatosSin, { resultado: { nit: pObj } });
              resolve(res.data);
              commit(types.mutations.SetValidacionEnCurso, {
                exito: false,
                error: true,
                consultando: false,
                mensaje: res.data.message,
              });
            }
          } else {
            //TODO: mensaje de error en la consulta volver a preguntar
            commit(types.mutations.SetValidacionEnCurso, {
              exito: false,
              error: true,
              consultando: false,
              mensaje: res.data ? res.data.message : "El NIT ingresado es erroneo, favor verifique.",
            });
          }
        });
    });
  },
  [types.actions.LimpiarBusquedaNit]: ({ commit }) => { //no se usa
    commit(types.mutations.SetValidacionEnCurso, {})
  },
  [types.actions.ValidarDatosRepresentante]: ({ commit }, pObj) => {
    return new Promise((resolve, reject) => {
      commit(types.mutations.SetValidacionEnCurso, {
        exito: false,
        error: false,
        consultando: true,
        mensaje:"Consultando con el Servicio General de Identificación Personal"
      });

      Vue.prototype.$http
        .post(`credencial/solicitud_credencial/verificarCi/${localStorage.getItem("tokenC")}`, pObj)
        .then((res) => {
          if (res.status == 200) {
            if (res.data.status == 200) {
              commit(types.mutations.SetValidacionSegip, { status: true, message: res.data.message });
              resolve(true);
              commit(types.mutations.SetValidacionEnCurso, {
                exito: true,
                error: false,
                consultando: false,
                mensaje:"Se valido correctamente"
              });
            }

            else {
              commit(types.mutations.SetValidacionSegip, { status: false, message: res.data.message });
              resolve(false);
              commit(types.mutations.SetValidacionEnCurso, {
                exito: false,
                error: true,
                consultando: false,
                mensaje: res.data.message
              });
            }
          } else {
            //TODO: Enviar mensaje de volver a intentar
          }
        });

      // }else{
      //commit(types.mutations.SetValidacionSegip, state:false)

      //resolve(false)
      //}.catch(){//error en caso de que segip no responda bien??
      //mensaje para volver a intentar
      //}
      //})
    });
  },
  [types.actions.EnvioDeSolicitud]: ({ commit }, pObj) => { //envia los datos al final
    commit(types.mutations.SetValidacionEnCurso, {
      exito: false,
      error: false,
      consultando: true,
    });

    let dataSolicitud = {
      pCorreo : pObj
    }

    return new Promise((resolve, reject) => {

      Vue.prototype.$http
        .post(
          `credencial/solicitud_credencial/registrarSolicitud`,
          dataSolicitud
        )
        .then((res) => {

          if (res.status == 200) {
            commit(types.mutations.SetFormularioEnviado, true)
            resolve(true);
            commit(types.mutations.SetValidacionEnCurso, {
              exito: true,
              error: false,
              consultando: false,
            });

          } else {
            //TODO: mensaje de no se pudo volver a intentar
            commit(types.mutations.SetValidacionEnCurso, {
              exito: false,
              error: true,
              consultando: false,
            });
          }
        });
    });
  },
  [types.actions.RecuperarDatosGuardados]: ({ commit }, pObj) => {
    return new Promise((resolve, reject) => {
      commit(types.mutations.SetValidacionEnCurso, {
        exito: false,
        error: false,
        consultando: true,
        mensaje: "Recuperando la información"
      });


      Vue.prototype.$http
        .post(`credencial/solicitud_credencial/verificacionCorreo`, pObj)
        .then((res) => {

          if (res.status == 200) {
            if (res.data.status == 200) {

              commit(types.mutations.SetDatosGuardados, res.data);
              resolve(res.data);
              commit(types.mutations.SetValidacionEnCurso, {
                exito: true,
                error: false,
                consultando: false
              });
            } else {
              commit(types.mutations.SetDatosSin, null);
              resolve(null);
              commit(types.mutations.SetValidacionEnCurso, {
                exito: false,
                error: true,
                consultando: false
              });
            }
          } else {
            //TODO: nmensaje de volver a intentar
            resolve(null);
            commit(types.mutations.SetValidacionEnCurso, {
              exito: false,
              error: true,
              consultando: false,
              mensaje: res.message
            });
          }
        });
    });
  },

  [types.actions.ListaDocumentosCredenciales]: ({ commit }, pObj) => {
    commit(types.mutations.SetDocumentosCredenciales, []);
    return new Promise((resolve, reject) => {
      Vue.prototype.$http
        .get(
          `credencial/solicitud_credencial/list_documentos/${pObj.solicitudId}/${pObj.criterio}`
        )
        .then((r) => {
          commit(types.mutations.SetDocumentosCredenciales, r.data);
          resolve(r);
        });
    });
  },

  [types.actions.SubirDocumentosCredenciales]: ({ commit }, pObj) => {
    return new Promise((resolve, reject) => {
      Vue.prototype.$http
        .post(`credencial/documento_credencial/upload_archivo`, pObj)
        .then((r) => {
          resolve(r);
        });
    });
  },
  [types.actions.EliminarDocumentoCredenciales]: ({ commit }, pObj) => {
    return new Promise((resolve, reject) => {
      Vue.prototype.$http
        .delete(`credencial/documento_credencial/detalle/delete/${pObj.id}`, pObj.tokenAcceso)
        .then((r) => {
          resolve(r);
        });
    });
  },
  [types.actions.EnviarSolicitud]: ({ commit }, payload) => {
    commit(types.mutations.SetValidacionEnCurso, {
      exito: false,
      error: false,
      consultando: true,
      mensaje: "Enviando Información"
    });

    return new Promise((resolve, reject) => {

      Vue.prototype.$http
        .post(`credencial/solicitud_credencial/enviarSolicitud`, payload)
        .then((res) => {

          if(res.data.status === 200){

          resolve(res);
          commit(types.mutations.SetValidacionEnCurso, {
            exito: true,
            error: false,
            consultando: false,
            mensaje: "Se ha enviado la solicitud de credencial"
          });
          commit(types.mutations.SetFormularioEnviado, true)
          }
          if(res.data.status ===404){
            resolve(res);
            commit(types.mutations.SetValidacionEnCurso, {
              exito: false,
              error: true,
              consultando: false,
              mensaje: res.data.message
            });
            commit(types.mutations.SetFormularioEnviado, false)
          }
        });

      /*
       setTimeout(()=>{
         commit(types.mutations.SetValidacionEnCurso, {
           exito: false,
           error: true,
           consultando: false,
           mensaje:"Se ha enviado la solicitud de credencialttttttttttttttttttttttttt"
        }, 6000)
     });
     */
    });
  },
  [types.actions.GenerarFormularioR_0530]: ({ commit }, pToken) => {
    commit(types.mutations.SetValidacionEnCurso, {
      exito: false,
      error: false,
      consultando: true,
      mensaje: "Enviando Información"
    });
    return new Promise((resolve, reject) => {
      Vue.prototype.$http.getFiles(`credencial/reporte/pdf/R-0530/${pToken}`)
        .then(r => {
          resolve(r);
          commit(types.mutations.SetValidacionEnCurso, {
            exito: true,
            error: false,
            consultando: false,
            mensaje: "Se ha enviado la solicitud de credencial"
          });

        });
    });
  },
  // OBTENER DOCUMENTO ADJUNTO PAJEL
  [types.actions.ObtenerDocumentoAdjunto]: ({ commit }, pObj) => {
    return new Promise((resolve, reject) => {
      Vue.prototype.$http.getFiles(`credencial/documento_credencial/descargar_archivo?pNombreArchivo=${encodeURIComponent(pObj.pNombreArchivo)}&authorization=${pObj.tokenAcceso}`)
        .then(r => {
          resolve(r);
        });
    });
  },
};

export default {
  state,
  actions,
  getters,
  mutations,
};
